import { extensionToLabelMap } from './constants';
import { getEmbedHTML } from './getEmbedHTML';
import { urlConstructor } from './urlConstructor';
const embedConstructor = async file => {
  const {
    external_id,
    filename,
    id
  } = file;
  const arrFileName = file.filename?.split('.');
  const ext = arrFileName[arrFileName.length - 1].toLowerCase();
  const typeOfFile = ext => extensionToLabelMap.get(ext);
  const type = typeOfFile(ext);
  const url = urlConstructor(external_id, filename, type);
  return await getEmbedHTML(type, url, filename, id);
};
export default embedConstructor;